import { combineReducers } from 'redux'
import { allLgas } from './lgaReducer'

const lgaReducers = combineReducers({
  allLgas,
})

export default lgaReducers
